import { GetterTree } from 'vuex'
import { IAdminState, IAdminInfo, EAdminRole } from './types'

const getters: GetterTree<IAdminState, any> = {
  adminList (state: IAdminState) {
    return state.adminList || []
  },

  superAdminList (state: IAdminState, getters) {
    return getters.adminList.filter((user: IAdminInfo) => user.dev_role_id === EAdminRole.SUPER)
  },

  generalAdminList (state: IAdminState, getters) {
    return getters.adminList.filter((user: IAdminInfo) => user.dev_role_id === EAdminRole.GENERAL)
  }
}

export default getters
